import React, { useState, useEffect, useRef } from "react";
import { useSelector } from 'react-redux';
import axios from "axios";
import { Button, Divider, Drawer, Form, IconButton, InputGroup, Message, Modal, Panel, Schema, SelectPicker, Stack, Table, TagPicker, Toggle, useToaster } from 'rsuite';
import RefreshIcon from '@rsuite/icons/legacy/Refresh';
import InfoIcon from '@rsuite/icons/legacy/Info';
import EditIcon from '@rsuite/icons/legacy/Edit2';
import MoreIcon from '@rsuite/icons/legacy/More';
import UserPlusIcon from '@rsuite/icons/legacy/UserPlus';
import EyeIcon from '@rsuite/icons/legacy/Eye';
import EyeSlashIcon from '@rsuite/icons/legacy/EyeSlash';
import DeleteIcon from '@rsuite/icons/Trash';
import ResetIcon from '@rsuite/icons/legacy/UnlockAlt';
import VisitsIcon from 'assets/img/stats_views.svg';
import UVIcon from 'assets/img/stats_uv.svg';

const { Column, HeaderCell, Cell } = Table;
const TableRow = ({ children, onDrag, id, rowData, user, ...rest }) => {
    return (
        <div {...rest} style={{ opacity: (!rowData.active ? 0.7 : 1), fontWeight: rowData.sub === user.sub ? "bold" : "normal" }}>
            {children}
        </div>
    );
}
const modelNWUser = Schema.Model({
    userName: Schema.Types.StringType()
        .isEmail('Ingrese un email válido.')
        .isRequired('Este campo es requerido.'),
    userPass: Schema.Types.StringType()
        .isRequired('Este campo es requerido.')
        .minLength(6, 'La contraseña debe contener al menos 6 caracteres')
        .containsLetter('La contraseña debe contener al menos una letra')
        .containsUppercaseLetter('La contraseña debe contener al menos un caracter en mayúscula')
        .containsLowercaseLetter('La contraseña debe contener al menos un caracter en minúscula')
        .containsNumber('La contraseña debe contener al menos un número')
        .addRule((value, data) => ['!', '*', '#', '$', '%', '&', '/', '(', ')', '=', '?',].some(x => value.indexOf(x) >= 0), 'La contraseña debe contener al menos un símbolo !*#$%&/()=?'),
    givenName: Schema.Types.StringType()
        .isRequired('Este campo es requerido.'),
    familyName: Schema.Types.StringType()
        .isRequired('Este campo es requerido.'),
    userType: Schema.Types.StringType()
        .isRequired('Este campo es requerido.'),
    userSites: Schema.Types.ArrayType()
        .minLength(1, 'Seleccione al menos una empresa'),
    userList: Schema.Types.ArrayType()
        .addRule((value, data) => { return !(value.length == 0 && data.userType == 'user'); }, 'Seleccione al menos una lista.'),
});
const modelUPDUser = Schema.Model({
    givenName: Schema.Types.StringType()
        .isRequired('Este campo es requerido.'),
    familyName: Schema.Types.StringType()
        .isRequired('Este campo es requerido.'),
    userType: Schema.Types.StringType()
        .isRequired('Este campo es requerido.'),
    userSites: Schema.Types.ArrayType()
        .minLength(1, 'Seleccione al menos una empresa'),
    userList: Schema.Types.ArrayType()
        .addRule((value, data) => { return !(value.length == 0 && data.userType == 'user'); }, 'Seleccione al menos una lista.'),
});
const messageDataError = (
    <Message showIcon type="error" closable>
        Ocurrió un error al intentar actualizar los datos.
    </Message>
);
const messageDataINS = (
    <Message showIcon type="success" closable>
        Se ingresó correctamente la cuenta de usuario.
    </Message>
);
const messageDataUPD = (
    <Message showIcon type="success" closable>
        Se actualizó correctamente la cuenta de usuario.
    </Message>
);
const messageDataDEL = (
    <Message showIcon type="success" closable>
        Se eliminó correctamente la cuenta de usuario.
    </Message>
);

function Users({ setWorking }) {
    const user = useSelector(state => state.auth.user)
    const site = useSelector(state => state.site);
    const apiURL = site.site.apiServer;
    const toaster = useToaster();
    const userData = { userID: '', userName: '', userPass: '', givenName: '', familyName: '', userType: '', userSites: [], userList: [], }
    const [loading, setLoading] = useState(false);
    const [showInfo, setShowInfo] = useState(false);
    const [showConfirm, setShowConfirm] = useState(false);
    const [sortColumn, setSortColumn] = useState();
    const [sortType, setSortType] = useState();
    const [users, setUsers] = useState([]);
    const [statsV, setStatsV] = useState(0);
    const [statsUV, setStatsUV] = useState(0);
    const [statsPublish, setStatsPublish] = useState(0);
    const [statsActivePublish, setStatsActivePublish] = useState(0);
    const [siteAccessRoles, setSiteAccessRoles] = useState([]);
    const [userAccessRoles, setUserAccessRoles] = useState([]);
    const [listAccessRoles, setListAccessRoles] = useState([]);
    const [selectedUser, setSelectedUser] = useState(null);
    const [pwFieldVisible, setPWFieldVisible] = React.useState(true);
    const [newUserOpen, setNewUserOpen] = useState(false);
    const [updUserOpen, setUpdUserOpen] = useState(false);
    const selectedSub = useRef('');
    const formNWRef = React.useRef();
    const formUPDRef = React.useRef();
    const [userListNWDisabled, setUserListNWDisabled] = useState(false);
    const [userListUPDDisabled, setUserListUPDDisabled] = useState(false);
    const [formNWValue, setFormNWValue] = React.useState(userData);
    const [formUPDValue, setFormUPDValue] = React.useState(userData);
    const handleFormNWSubmit = async () => {
        if (!formNWRef.current.check())
            return;
        setWorking(true);
        let fd = new FormData();
        fd.append('user_data', window.btoa(JSON.stringify(formNWValue)));
        await axios
            .postForm(`${process.env.REACT_APP_AUTH_SERVER_URL}/users-manager/create`, fd, { token: JSON.parse(atob(localStorage.getItem("token"))).at, 'Content-Type': 'multipart/form-data', headers: { "DomainKey": "marcelococciolo", }})
            .then((response) => {
                fetchData();
                setNewUserOpen(false);
                if (response.data.result)
                    setTimeout(() => toaster.push(messageDataINS, { placement: "topCenter", duration: 5000 }), 500);
                else
                    setTimeout(() => toaster.push(messageDataError, { placement: "topCenter", duration: 5000 }), 500);
            })
            .catch((e) => {
                console.log(e);
                setTimeout(() => toaster.push(messageDataError, { placement: "topCenter", duration: 5000 }), 500);
            })
            .finally(() => {
                setWorking(false);
            });
    };
    const handleFormUPDSubmit = async () => {
        if (!formUPDRef.current.check())
            return;
        setWorking(true);
        let fd = new FormData();
        fd.append('user_data', window.btoa(JSON.stringify(formUPDValue)));
        await axios
            .putForm(`${process.env.REACT_APP_AUTH_SERVER_URL}/users-manager/update`, fd, { token: JSON.parse(atob(localStorage.getItem("token"))).at, 'Content-Type': 'multipart/form-data', headers: { "DomainKey": "marcelococciolo", } })
            .then((response) => {
                fetchData();
                setUpdUserOpen(false);
                if (response.data.result)
                    setTimeout(() => toaster.push(messageDataUPD, { placement: "topCenter", duration: 5000 }), 500);
                else
                    setTimeout(() => toaster.push(messageDataError, { placement: "topCenter", duration: 5000 }), 500);
            })
            .catch((e) => {
                console.log(e);
                setTimeout(() => toaster.push(messageDataError, { placement: "topCenter", duration: 5000 }), 500);
            })
            .finally(() => {
                setWorking(false);
            });
    }

    const handleSortColumn = (sc, st) => {
        if (sc && st) {
            console.log('sorting');
            console.log(sc);
            setUsers([...users].sort((a, b) => {
                let x = a[sc], y = b[sc];
                if (typeof x === 'string' && typeof y === 'string')
                    return st === 'asc' ? ('' + x).localeCompare(y) : ('' + y).localeCompare(x);
                return st === 'asc' ? x - y : y - x;
            }));
        }
        setSortColumn(sc);
        setSortType(st);
    };
    
    const ActionCell = ({ rowData, dataKey, ...props }) => {
        return (
            <Cell {...props} className="link-group">
                <IconButton appearance="subtle" icon={<InfoIcon />} onClick={() => {
                    selectedSub.current = rowData.sub;
                    setSelectedUser(rowData);
                    setFormUPDValue({
                        userID: rowData.sub,
                        userName: rowData.userName,
                        givenName: rowData.givenName,
                        familyName: rowData.familyName,
                        userType: userAccessRoles.find((x) => x.name === rowData.roles.find((z) => z === x.name)).name,
                        userSites: siteAccessRoles.filter((x) => x.name === rowData.roles.find((z) => z === x.name)).map(u => u.name),
                        userList: listAccessRoles.filter((x) => x.name === rowData.roles.find((z) => z === x.name)).map(u => u.name),
                    })
                    setUserListUPDDisabled(userAccessRoles.find((x) => x.name === rowData.roles.find((z) => z === x.name)).name != 'user');
                    fetchStats();
                }} />
            </Cell>
        );
    };

    const deleteUser = async () => {
        setWorking(true);
        await axios
            .delete(`${process.env.REACT_APP_AUTH_SERVER_URL}/users-manager/delete/${selectedUser.sub}`, { token: JSON.parse(atob(localStorage.getItem("token"))).at, headers: { "DomainKey": "marcelococciolo",  } })
            .then((response) => {
                console.log(response);
                //toaster.push(messageDataError, { placement: "topCenter", duration: 5000 });
                setShowConfirm(false);
                setShowInfo(false);
                fetchData();
                //setTimeout(() => toaster.push(<Message showIcon type="success" closable>Publicaci&oacute;n eliminada</Message>, { placement: "topCenter", duration: 5000 }), 500);
            })
            .catch((e) => {
                console.log(e);
                //toaster.push(messageDataError, { placement: "topCenter", duration: 5000 });
            })
            .finally(() => {
                setWorking(false);
            });
    }
    const fetchData = async () => {
        setLoading(true);
        let fd = new FormData();
        fd.append('secret', "marcelococciolo");
        await axios
            .get(`${process.env.REACT_APP_AUTH_SERVER_URL}/users-manager/roles`, {
                token: JSON.parse(atob(localStorage.getItem("token"))).at, headers: { "DomainKey": "marcelococciolo", }
            })
            .then((response) => {
                setSiteAccessRoles(response.data.result.filter(x => x.type === 'site_access'));
                setUserAccessRoles(response.data.result.filter(x => x.type === 'user_access'));
                setListAccessRoles(response.data.result.filter(x => x.type === 'list_perm'));
            })
            .catch((e) => {
                console.log(e);
            });
        console.log(siteAccessRoles);
        await axios
            .get(`${process.env.REACT_APP_AUTH_SERVER_URL}/users-manager/users`, {
                token: JSON.parse(atob(localStorage.getItem("token"))).at, headers: { "DomainKey": "marcelococciolo", }
            })
            .then((response) => {
                console.log(response)
                setUsers(response.data.result);
            })
            .catch((e) => {
                console.log(e);
            })
            .finally(() => {
                setLoading(false);
            });
    }
    const fetchStats = async () => {
        console.log(selectedUser);
        setLoading(true);
        await axios
            .get(apiURL + "/catalogo/stats/" + selectedSub.current, { headers: { token: JSON.parse(atob(localStorage.getItem("token"))).at }, })
            .then((response) => {
                console.log(response);
                setShowInfo(true);
                setStatsV(response.data.global[0].pageViews);
                setStatsUV(response.data.global[0].uniqueViews);
                setStatsPublish(response.data.counts[0].publishCount);
                setStatsActivePublish(response.data.counts[0].activePublishCount);
            })
            .catch((e) => { console.log(e) })
            .finally(() => setLoading(false));
    };

    useEffect(() => {
        console.log('Settings begin');
        console.log(user);
        fetchData();
        return () => { console.log('Settings end'); }
    }, []);

    return (
        <>
            <Panel header={<Stack alignItems="baseline" spacing={10}>
                <Stack.Item grow={1}>
                    <h4 className="title">Administración de usuarios</h4>
                </Stack.Item>
                <Button appearance="primary" startIcon={<UserPlusIcon />} onClick={() => setNewUserOpen(true)}>
                    Nuevo
                </Button>
                <Button appearance="subtle" startIcon={<RefreshIcon />} onClick={() => fetchData()}>
                    Actualizar
                </Button>
            </Stack>} bordered>
                <Table height={150} autoHeight data={users} id="table" loading={loading}
                    sortColumn={sortColumn} locale={{ loading: "cargando datos ..." }}
                    sortType={sortType} onSortColumn={handleSortColumn} virtualized
                    renderRow={(children, rowData) => {
                        return rowData ? (
                            <TableRow key={rowData.value} rowData={rowData} id={rowData.value} user={user}>
                                {children}
                            </TableRow>
                        ) : (children);
                    }}>
                    <Column width={300} sortable>
                        <HeaderCell>Usuario</HeaderCell>
                        <Cell dataKey="userName" />
                    </Column>
                    <Column flexGrow={1} sortable>
                        <HeaderCell>Apellido</HeaderCell>
                        <Cell dataKey="familyName" />
                    </Column>
                    <Column flexGrow={1} sortable>
                        <HeaderCell>Nombre</HeaderCell>
                        <Cell dataKey="givenName" />
                    </Column>
                    <Column flexGrow={1} sortable>
                        <HeaderCell>Tipo acceso</HeaderCell>
                        <Cell>{rowData => `${userAccessRoles.find((x) => x.name === rowData.roles.find((z) => z === x.name)).friendlyName}`}</Cell>
                    </Column>
                    <Column flexGrow={1}>
                        <HeaderCell>Empresas</HeaderCell>
                        <Cell>{rowData => `${siteAccessRoles.filter((x) => x.name === rowData.roles.find((z) => z === x.name)).map(u => u.friendlyName).join(', ')}`}</Cell>
                    </Column>
                    <Column flexGrow={2}>
                        <HeaderCell>Listas de precios</HeaderCell>
                        <Cell>{rowData => rowData.roles.includes('user') ?
                            `${listAccessRoles.filter((x) => x.name === rowData.roles.find((z) => z === x.name)).map(u => u.friendlyName).join(', ')}` :
                            'Todas'}</Cell>
                    </Column>
                    <Column width={50}>
                        <HeaderCell>
                            <MoreIcon />
                        </HeaderCell>
                        <ActionCell dataKey="value" />
                    </Column>
                </Table>
            </Panel>
            <Modal backdrop="static" keyboard={false} open={newUserOpen} onClose={() => { setUserListNWDisabled(true); setNewUserOpen(false); setFormNWValue(userData); }} size="xs">
                <Modal.Header>
                    <Modal.Title>Nuevo usuario</Modal.Title>
                </Modal.Header>
                <Modal.Body className="new-user-panel">
                    <Form fluid onChange={setFormNWValue} ref={formNWRef} formValue={formNWValue} model={modelNWUser} style={{ margin: 5 }} className="new-user">
                        <Form.Group controlId="newuser-user_name">
                            <Form.Control placeholder="Nombre de usuario" name="userName" type="email" autoComplete="off" size="md" />
                        </Form.Group>
                        <Form.Group controlId="newuser-user_pass">
                            <InputGroup inside>
                                <Form.Control placeholder="Contraseña" name="userPass" type={pwFieldVisible ? 'text' : 'password'} autoComplete="off" size="md" />
                                <InputGroup.Button tabIndex="-1" onClick={() => setPWFieldVisible(!pwFieldVisible)} size="md">{pwFieldVisible ? <EyeIcon /> : <EyeSlashIcon />}</InputGroup.Button>
                            </InputGroup>
                        </Form.Group>
                        <Form.Group controlId="newuser-given_name">
                            <Form.Control placeholder="Nombre" name="givenName" type='text' />
                        </Form.Group>
                        <Form.Group controlId="newuser-family_name">
                            <Form.Control placeholder="Apellido" name="familyName" type='text' />
                        </Form.Group>
                        <Form.Group controlId="newuser-user_type">
                            <Form.Control block={true} placeholder="Tipo de cuenta" name="userType" accepter={SelectPicker} data={userAccessRoles} labelKey="friendlyName" valueKey="name" searchable={false}
                                onChange={(e) => {
                                    if (e != null && e != 'user') {
                                        setFormNWValue({ ...formNWValue, userType: e, userList: [] });
                                        setUserListNWDisabled(true);
                                    }
                                    else
                                        setUserListNWDisabled(false);
                                }} />
                        </Form.Group>
                        <Form.Group controlId="newuser-user_sites">
                            <Form.Control block={true} placeholder="Empresas permitidas" name="userSites" accepter={TagPicker} data={siteAccessRoles} labelKey="friendlyName" valueKey="name" />
                        </Form.Group>
                        <Form.Group controlId="newuser-user_list">
                            <Form.Control disabled={userListNWDisabled} block={true} placeholder="Lista de precios permitidas" name="userList" accepter={TagPicker} data={listAccessRoles} labelKey="friendlyName" valueKey="name" />
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button appearance="primary" onClick={handleFormNWSubmit}>
                        Crear
                    </Button>
                    <Button onClick={() => setNewUserOpen(false)} appearance="subtle">
                        Cancelar
                    </Button>
                </Modal.Footer>
            </Modal>
            <Modal backdrop="static" keyboard={false} open={updUserOpen} onClose={() => { setUserListUPDDisabled(true); setUpdUserOpen(false); setFormUPDValue(userData); }} size="xs">
                <Modal.Header>
                    <Modal.Title>Editar usuario</Modal.Title>
                </Modal.Header>
                <Modal.Body className="new-user-panel">
                    <Form fluid onChange={setFormUPDValue} ref={formUPDRef} formValue={formUPDValue} model={modelUPDUser} style={{ margin: 5 }} className="new-user">
                        <Form.Group controlId="upduser-given_name">
                            <Form.Control placeholder="Nombre" name="givenName" type='text' />
                        </Form.Group>
                        <Form.Group controlId="upduser-family_name">
                            <Form.Control placeholder="Apellido" name="familyName" type='text' />
                        </Form.Group>
                        <Form.Group controlId="upduser-user_type">
                            <Form.Control block={true} placeholder="Tipo de cuenta" name="userType" accepter={SelectPicker} data={userAccessRoles} labelKey="friendlyName" valueKey="name" searchable={false}
                                onChange={(e) => {
                                    if (e != null && e != 'user') {
                                        setFormUPDValue({ ...formUPDValue, userType: e, userList: [] });
                                        setUserListUPDDisabled(true);
                                    }
                                    else
                                        setUserListUPDDisabled(false);
                                }} />
                        </Form.Group>
                        <Form.Group controlId="newuser-user_sites">
                            <Form.Control block={true} placeholder="Empresas permitidas" name="userSites" accepter={TagPicker} data={siteAccessRoles} labelKey="friendlyName" valueKey="name" />
                        </Form.Group>
                        <Form.Group controlId="newuser-user_list">
                            <Form.Control disabled={userListUPDDisabled} block={true} placeholder="Lista de precios permitidas" name="userList" accepter={TagPicker} data={listAccessRoles} labelKey="friendlyName" valueKey="name" />
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button appearance="primary" onClick={handleFormUPDSubmit}>
                        Actualizar
                    </Button>
                    <Button onClick={() => setUpdUserOpen(false)} appearance="subtle">
                        Cancelar
                    </Button>
                </Modal.Footer>
            </Modal>
            <Drawer backdrop="static" size="sm" placement="right" open={showInfo} onClose={() => setShowInfo(false)}>
                <Drawer.Header style={{ alignItems: "center" }}>
                    <Drawer.Title>{selectedUser != null ? selectedUser.userName : ''}</Drawer.Title>
                    {selectedUser != null && selectedUser.sub !== user.sub && (
                        <Drawer.Actions>
                            <Toggle checked={selectedUser && selectedUser.active} onChange={(value) => {/*toogleActive(value)*/ }} checkedChildren="Activo" unCheckedChildren="Inactivo" />
                        </Drawer.Actions>
                    )}
                </Drawer.Header>
                <Drawer.Body>
                    <small>Nombre</small>
                    <p style={{ fontWeight: "bold", marginBottom: 10 }}>{selectedUser != null ? `${selectedUser.familyName}, ${selectedUser.givenName}` : ''}</p>
                    <small>Tipo de acceso</small>
                    <p style={{ fontWeight: "bold", marginBottom: 10 }}>{selectedUser != null ? `${userAccessRoles.find((x) => x.name === selectedUser.roles.find((z) => z === x.name)).friendlyName}` : ''}</p>
                    <small>Empresas habilitadas</small>
                    <p style={{ fontWeight: "bold", marginBottom: 10 }}>{selectedUser != null ? `${siteAccessRoles.filter((x) => x.name === selectedUser.roles.find((z) => z === x.name)).map(u => u.friendlyName).join(', ')}` : ''}</p>
                    <small>Listas de precios</small>
                    <p style={{ fontWeight: "bold", marginBottom: 10 }}>{selectedUser != null ? (selectedUser.roles.includes('user') ?
                        `${listAccessRoles.filter((x) => x.name === selectedUser.roles.find((z) => z === x.name)).map(u => u.friendlyName).join(', ')}` :
                        'Todas') : ''}</p>
                    <small>Publicaciones</small>
                    <p style={{ fontWeight: "bold", marginBottom: 10 }}>{`Total: ${statsPublish} / Activas: ${statsActivePublish}`}</p>

                    <Divider>Acciones para la cuenta</Divider>

                    <Stack spacing={20} direction="row" alignItems="baseline" justifyContent="center">
                        <IconButton title="Editar cuenta" icon={<EditIcon />} appearance="subtle" size="sm" style={{ color: "var(--rs-btn-primary-bg)" }} onClick={() => { setShowInfo(false); setUpdUserOpen(true); }}>
                            Editar
                        </IconButton>
                        <IconButton title="Reestablecer contraseña" icon={<ResetIcon />} appearance="subtle" size="sm" style={{ color: "var(--rs-btn-primary-bg)" }} onClick={() => { }}>
                            Reestablecer
                        </IconButton>
                        <IconButton title="Eliminar cuenta" icon={<DeleteIcon />} appearance="subtle" size="sm" style={{ color: "#c00" }} onClick={() => setShowConfirm(true)}>
                            Eliminar
                        </IconButton>
                    </Stack>
                    

                    <Divider>Estadísticas</Divider>
                    <Stack alignItems="center" spacing={20}>
                        <Stack.Item grow={1} style={{ position: "relative", padding: 5, backgroundColor: "var(--rs-gray-100)" }}>
                            <img src={VisitsIcon} style={{ position: "absolute", width: 100, top: 10, opacity: .5 }} />
                            <div style={{ textAlign: "right" }}>Visitas</div>
                            <div style={{ textAlign: "right", fontSize: "24px", fontWeight: "bold", paddingRight: 5 }}>{statsV}</div>
                        </Stack.Item>
                        <Stack.Item grow={1} style={{ position: "relative", padding: 5, backgroundColor: "var(--rs-gray-100)" }}>
                            <img src={UVIcon} style={{ position: "absolute", width: 100, top: 10, opacity: .5 }} />
                            <div style={{ textAlign: "right" }}>Visitas únicas</div>
                            <div style={{ textAlign: "right", fontSize: "24px", fontWeight: "bold", paddingRight: 5 }}>{statsUV}</div>
                        </Stack.Item>
                    </Stack>
                </Drawer.Body>
            </Drawer>
            <Modal backdrop="static" keyboard={true} open={showConfirm} onClose={() => setShowConfirm(false)}>
                <Modal.Header>
                    <Modal.Title>Confirmaci&oacute;n</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    ¿Está seguro de eliminar al usuario seleccionado?"
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={() => deleteUser()} appearance="primary">
                        Aceptar
                    </Button>
                    <Button onClick={() => setShowConfirm(false)} appearance="subtle">
                        Cancelar
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default Users;